module.exports = __webpack_public_path__ + "img/icon_near11.f7ff38e5.svg";